import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useCrmAccess } from "@/hooks/use-crm-access";
import { MfaGate } from "./MfaGate";

interface CrmProtectedRouteProps {
  children: React.ReactNode;
}

export const CrmProtectedRoute: React.FC<CrmProtectedRouteProps> = ({ children }) => {
  const { session, loading } = useAuth();
  const { data: hasCrmAccess, isLoading: crmLoading } = useCrmAccess();

  if (loading || crmLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (!hasCrmAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <MfaGate>{children}</MfaGate>;
};